import resource from '@generalScope/ceRouter/resource'
import monitor from '@generalScope/eeRouter/monitor'
import iam from '@generalScope/eeRouter/iam'
import bill from '@generalScope/eeRouter/bill'
import system from '@generalScope/eeRouter/system'
import dashboard from '@generalScope/eeRouter/dashboard'
import tenant from './tenant'

export default [
  dashboard,
  resource,
  monitor,
  iam,
  bill,
  tenant,
  system,
]
